import React from "react";
import type { Roster } from "../api/types";
import { formatUserHandle } from "../../../utils/userHandle";

/** Everyone who joined, in join order, mine highlighted. */
const RosterList: React.FC<{ roster: Roster | undefined }> = ({ roster }) => {
  if (!roster) return null;
  return (
    <section className="gm-panel" aria-label="Players">
      <h2 className="gm-panel__title">
        {roster.count === 1 ? "1 player in" : `${roster.count} players in`}
      </h2>
      {roster.players.length > 0 ? (
        <ul className="gm-roster">
          {roster.players.map((p) => (
            <li key={p.username} className={p.me ? "gm-is-me" : undefined}>
              {formatUserHandle(p.username, p.emoji)}
            </li>
          ))}
        </ul>
      ) : (
        <p className="gm-muted">Nobody yet.</p>
      )}
    </section>
  );
};

export default RosterList;
